export default __webpack_public_path__ + "static/media/ChartDashboardOff.6594e96a.svg";